import AxiosCore from '@/services/api/core/axios_core'

export default {
  getKeyValue: (key) => {
    return AxiosCore.get(`key-value-store/${key}`)
  },
}
